import { EnvironmentProviders, inject, isDevMode, provideAppInitializer } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take, tap } from 'rxjs';

import { FeatureToggleService } from '../feature-toggle/feature-toggle.service';

import { GoogleAnalyticsService } from './google-analytics.service';

export function provideGoogleAnalytics(googleTagId: string | undefined): EnvironmentProviders[] {
  return googleTagId
    ? [
      provideAppInitializer(() => {
        const featureToggleService = inject(FeatureToggleService);
        const googleAnalyticsService = inject(GoogleAnalyticsService);

        return toObservable(featureToggleService.initialized).pipe(
          filter((initialized) => initialized),
          tap(() => {
            if (featureToggleService.isEnabled('fvdr-altair-ga-enabled') && !isDevMode()) {
              googleAnalyticsService.initialize(googleTagId);
            }
          }),
          take(1),
        );
      }),
    ]
    : [];
}
